import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Button } from '@hivebrite/design-system/Button';

import type {
  MentorProfile,
  Program,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import { getLowerCaseMentorLabel } from 'hb-react/frontoffice/apps/Mentoring/utils';
import { getApplyToBeMentorUrl } from 'hb-react/frontoffice/apps/Mentoring/utils/urlsUtils';

interface StatusButtonProps {
  status: MentorProfile['status'] | null;
  mentor_label: Program['mentor_label'];
  parent_type: Program['parent_type'];
  parent_id: Program['parent_id'];
  id: Program['id'];
  disabledAccess?: boolean;
}

const StatusButton = ({
  status,
  mentor_label: mentorLabel,
  parent_type: parentType,
  parent_id: parentId,
  id: programId,
  disabledAccess,
}: StatusButtonProps) => {
  const navigate = useNavigate();

  const applicationUrl = getApplyToBeMentorUrl({
    parentType,
    programId,
    parentId,
  });

  if (status === null) {
    return (
      <ButtonStyled
        onClick={() => navigate(applicationUrl)}
        isDisabled={disabledAccess}
      >
        {s__('Mentoring|Apply to be a %{label}').i__({
          label: getLowerCaseMentorLabel(mentorLabel),
        })}
      </ButtonStyled>
    );
  }

  if (status === 'rejected_can_reapply') {
    return (
      <ButtonStyled
        onClick={() => navigate(applicationUrl)}
        isDisabled={disabledAccess}
      >
        {s__('Mentoring|Reapply')}
      </ButtonStyled>
    );
  }

  if (status === 'pending') {
    return (
      <ButtonStyled isDisabled>
        {mentorLabel
          ? s__('Mentoring|Status: Pending Application')
          : s__('Mentoring|Mentor status: Pending Application')}
      </ButtonStyled>
    );
  }

  if (status === 'accepted') {
    return (
      <ButtonStyled isDisabled>
        {mentorLabel
          ? s__('Mentoring|Status: Active')
          : s__('Mentoring|Mentor status: Active')}
      </ButtonStyled>
    );
  }

  if (status === 'rejected_cannot_reapply') {
    return (
      <ButtonStyled isDisabled>
        {mentorLabel
          ? s__('Mentoring|Status: Rejected')
          : s__('Mentoring|Mentor status: Rejected')}
      </ButtonStyled>
    );
  }

  if (status === 'on_pause') {
    return (
      <ButtonStyled isDisabled>
        {mentorLabel
          ? s__('Mentoring|Status: On pause')
          : s__('Mentoring|Mentor status: On pause')}
      </ButtonStyled>
    );
  }

  if (status === 'terminated') {
    return (
      <ButtonStyled isDisabled>
        {mentorLabel
          ? s__('Mentoring|Status: Terminated')
          : s__('Mentoring|Mentor status: Terminated')}
      </ButtonStyled>
    );
  }

  return null;
};

export default StatusButton;

const ButtonStyled = styled(Button)`
  width: fit-content;
`;
